import {
  createDomainApi,
  type ExtractEntityType,
  type ExtractInputType,
} from '@skylabs-digital/react-proto-kit';
import { webhookInputSchema, webhookSchema } from '../schemas/webhook.schema';

export const webhooksApi = createDomainApi('webhooks', webhookSchema, webhookInputSchema);

export type WebhookEntity = ExtractEntityType<typeof webhooksApi>;
export type WebhookInputType = ExtractInputType<typeof webhooksApi>;
